/**
 * Why a price list item's amount must not be billed, even though the row holds
 * one.
 *
 * This **extends** `no_fixed_price` rather than replacing it. That flag was a
 * bare boolean for exactly one case, and two more have since been named. The
 * boolean keeps meaning _"do not bill this amount"_ and stays set for every
 * reason below; this enum says which one, so an operator reading a skipped unit
 * is not sent looking for a catalogue problem that is not there.
 *
 * - `KOSTENVORANSCHLAG` — the publisher prices the position at `Hoechstpreis =
 *   0`, which means *no fixed price*, never *free*: four Ergotherapie Schienen
 *   rows settled by Kostenvoranschlag.
 * - `NICHT_TRANSKRIBIERT` — the lineage's Anlage 2 has not been transcribed, so
 *   the contract facts behind the amount (LEGS, price basis, the copayment
 *   exception set, the X-substitution) are simply absent. Held by the two
 *   § 125a lineages: § 125a is the Blankoverordnung and out of v1 as a product
 *   concept (#1240), and until TM-9557 the HMP alone would make them billable
 *   with no contract behind the number.
 * - `AUSSERHALB_HEILMITTELERBRINGUNG` — the Anlage prices the position under its
 *   own heading *outside* the Heilmittelerbringung. Physio's `21901`
 *   (Geburtsvorbereitung) and `21904` (Rückbildungsgymnastik) are pegged to the
 *   § 134a Hebammenhilfevertrag and ruled out of scope by #1379; the HMP does
 *   not carry them at all.
 */
export var PriceSkipReason;
(function (PriceSkipReason) {
    PriceSkipReason["KOSTENVORANSCHLAG"] = "kostenvoranschlag";
    PriceSkipReason["NICHT_TRANSKRIBIERT"] = "nicht-transkribiert";
    PriceSkipReason["AUSSERHALB_HEILMITTELERBRINGUNG"] = "ausserhalb-heilmittelerbringung";
})(PriceSkipReason || (PriceSkipReason = {}));
//# sourceMappingURL=price-skip-reason.enum.js.map